import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getWebhookMutationKey } from '.';
import { webhookService } from '../../application/WebhookService';
import { Webhook } from '../../domain/webhook/Webhook';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

type CreateWebhookParams = {
  webhook: Webhook;
  projectId: string;
};
type CreateWebhookResponse = ServiceResponse<(params: CreateWebhookParams) => void, Webhook>;

// Hooks act as 'Adapter' layer.
export const useCreateWebhook = (): CreateWebhookResponse => {
  const queryClient = useQueryClient();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isLoading, isError, isSuccess, mutate } = useMutation(
    ({ webhook, projectId }: CreateWebhookParams): Promise<Webhook> => webhookService.createWebhook(webhook, projectId),
    {
      onSuccess: () => {
        console.info(`Webhook created successfully`);
        queryClient.invalidateQueries(getWebhookMutationKey());
      },
      onError: (err: any) => {
        console.info(`Webhook create error: `, err?.response);
        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading,
    run: (params: CreateWebhookParams) => mutate(params),
  };
};
